import request from "utils/request";
import { baseRequestURL } from "api/BaseAPI";

export function getAccounts(token) {
  // MB: Our request stack will handle adding tokens from the environment. Changing the behavior of this handling is not recommended.
  return request(baseRequestURL + "v1/accounts", { method: "GET" }).then((response) => response);

  // Old and should possibly be removed
  const options = {
    method: "GET"
  };

  if (token) {
    options.headers = {
      Authorization: "Bearer " + token
    };
  }

  return request(baseRequestURL + "v1/accounts", options, Boolean(token)).then((response) => response);
}

export function handleDelete(id) {
  return request(baseRequestURL + "v1/account/" + id, {
    method: "DELETE"
  }).then((response) => response);
}

export function getAccount(id) {
  return request(baseRequestURL + "v1/account/" + id, {
    method: "GET"
  }).then((response) => response);
}

export function testAccountLimits(id) {
  return request(baseRequestURL + "v1/account/" + id + "/capability_test", {
    method: "POST"
  }).then((response) => response);
}

export function createAccount(name, awsAccountId) {
  return request(baseRequestURL + "v1/accounts", {
    method: "POST",
    body: JSON.stringify({
      name: name,
      type: "aws",
      configuration: { aws_account_id: awsAccountId + "" }
    })
  }).then((response) => response);
}

export function createAzureAccount(name, config) {
  return request(baseRequestURL + "v1/accounts", {
    method: "POST",
    body: JSON.stringify({
      name: name,
      type: "azure",
      configuration: {
        azure_subscription_id: config.subscriptionID,
        region_name: config.regionName
        // cloud_base_url: config.cloudBaseUrl,
      }
    })
  });
}

export function createGCPAccount(name, config) {
  return request(baseRequestURL + "v1/accounts", {
    method: "POST",
    body: JSON.stringify({
      name: name,
      type: "gcp",
      configuration: {
        gcp_project_id: config.projectId,
        gcp_region: config.regionName
      }
    })
  });
}

export function updateLookerURL(id, lookerURL) {
  console.log(
    "what is lookerURL",
    lookerURL,
    JSON.stringify({
      configuration: {
        looker_export_url: lookerURL
      }
    })
  );

  return request(baseRequestURL + "v1/account/" + id, {
    method: "PATCH",
    body: JSON.stringify({
      configuration: {
        looker_export_url: lookerURL
      }
    })
  }).then((response) => response);
}

export function updateAccount(id, config) {
  return request(baseRequestURL + "v1/account/" + id, {
    method: "PATCH",
    body: JSON.stringify({
      configuration: {
        azure_subscription_id: config.azure_subscription_id,
        authorization_url: config.authorization_url,
        run_analysis_url: config.run_analysis_url,
        spark: {
          client_id: config.spark.client_id,
          client_secret: config.spark.client_secret,
          azure_tenant: config.spark.azure_tenant,
          resource_id: config.spark.resource_id
        }
      }
    })
  }).then((response) => response);
}
